import React, { useState } from 'react'
import PageShell from './PageShell'
import PageContainer from './components/PageContainer'
import PageHeader from './components/PageHeader'
import DataCard from './components/DataCard'
import ReportTable from './ReportTable'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Box from '@mui/material/Box'
import ScienceIcon from '@mui/icons-material/Science'
import FileUploadSection from './FileUploadSection'
import { useAuthStore } from './store/authStore'

export default function MFALite({ signOut }) {
  const userInfo = useAuthStore((state) => state.user)
  const updateRunState = useAuthStore((state) => state.updateRunState)
  const [selectedProduct, setSelectedProduct] = useState(null)

  if (!userInfo) {
    return null
  }

  const products = [
    { name: 'CloneSelectMFA', img: '/CloneSelectMFA.png' },
    { name: 'MFALite', img: '/MFAlite.png' },
    { name: 'TimeSegmentedMFA', img: '/TimeSegmentedMFA.png' },
    { name: 'BioInterpreter', img: '/BioInterpreter.png' },
    { name: 'CoreMFAtoMFALite', img: '/CoreMFAtoMFALite.png' },
    { name: 'BMSMFALite', img: '/BMSMFALite.png' },
    { name: 'PerfuseMFALite', img: '/PerfuseMFALite.png' },
  ]

  const imageStyle = (enabled, isSelected) => ({
    width: '230px',
    borderRadius: '15px',
    filter: !enabled ? 'grayscale(100%)' : 'none',
    opacity: !enabled ? 0.5 : 1,
    border: isSelected ? '4px solid #1976d2' : '4px solid transparent',
    cursor: enabled ? 'pointer' : 'not-allowed',
  })

  const handleProductSelection = (productName) => {
    setSelectedProduct(productName)
    products.forEach((product) => {
      const runKey = `run${product.name}`
      updateRunState(runKey, product.name === productName)
    })
  }

  const renderImageWithRadioButton = (product) => {
    const hasKey = `has${product.name}`

    // Skip rendering if the user lacks permission for the product
    if (!userInfo[hasKey]) {
      return null
    }

    const isSelected = selectedProduct === product.name

    return (
      <div
        style={{ position: 'relative', textAlign: 'center', margin: '10px' }}
        key={product.name}
        onClick={() => userInfo[hasKey] && handleProductSelection(product.name)}
      >
        <img
          src={product.img}
          alt={product.name}
          style={imageStyle(userInfo[hasKey], isSelected)}
        />
        <FormControlLabel
          value={product.name}
          control={<Radio color="primary" />}
          label=""
          checked={isSelected}
          disabled={!userInfo[hasKey]}
        />
      </div>
    )
  }

  return (
    <PageShell>
      <PageContainer>
        <PageHeader
          icon={<ScienceIcon />}
          title="Run Analysis"
          subtitle="Select a product to run on your input data"
        />

        <DataCard title="Select a product">
          <RadioGroup
            name="productSelection"
            value={selectedProduct}
            onChange={(event) => handleProductSelection(event.target.value)}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              gap: 2,
            }}
          >
            {products.map(renderImageWithRadioButton)}
          </RadioGroup>

          {selectedProduct && (
            <Box sx={{ mt: 3 }}>
              <FileUploadSection />
            </Box>
          )}
        </DataCard>

        <DataCard title="Job History" noPadding>
          <Box sx={{ maxHeight: 800, overflowY: 'auto' }}>
            <ReportTable />
          </Box>
        </DataCard>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.75rem' }}>
            v0.9.5
          </Box>
        </Box>
      </PageContainer>
    </PageShell>
  )
}
